import React from 'react';
import CustomerSearchPicker from './CustomerSearchPicker';

/**
 * Customer + search filters for the CI Ship-To Addresses directory (applies
 * server-side). The customer filter is a type-ahead search (not a <select>
 * preloaded with every customer on the account -- that doesn't scale past a
 * few hundred customers, let alone the 2000+ some real accounts have).
 */
export default function ShipToDirectoryFilters({
  siteId,
  filterCustomerId,
  filterCustomerLabel,
  onCustomerSelect,
  onCustomerClear,
  searchDraft,
  onSearchDraftChange,
  onApplySearch,
  loading,
}) {
  return (
    <div className="ci-card mb-3">
      <div className="p-3">
        <div className="row g-3 align-items-end">
          <div className="col-12 col-md-4">
            <label className="form-label mb-1" htmlFor="ci-shipto-customer-filter">
              Customer
            </label>
            <CustomerSearchPicker
              id="ci-shipto-customer-filter"
              siteId={siteId}
              value={filterCustomerId}
              valueLabel={filterCustomerLabel}
              onSelect={onCustomerSelect}
              onClear={onCustomerClear}
            />
          </div>
          <div className="col-12 col-md-5">
            <label className="form-label">Search</label>
            <input
              type="text"
              className="form-control"
              placeholder="Address, city, postal code, customer, or site"
              value={searchDraft}
              onChange={(e) => onSearchDraftChange(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') onApplySearch(); }}
            />
          </div>
          <div className="col-12 col-md-3 d-flex justify-content-md-end">
            <button
              type="button"
              className="btn btn-outline-primary"
              disabled={loading}
              onClick={onApplySearch}
            >
              {loading ? 'Searching…' : 'Search'}
            </button>
          </div>
        </div>
        <p className="text-muted small mb-0 mt-2">
          Searches address line, city, state, postal code, label, contact name, company, and the owning customer/site name.
        </p>
      </div>
    </div>
  );
}
